import { formatRelativeTime } from "@utils/formatRelativeTime";
import { format, isValid } from "date-fns";

import { Small } from "@fronterahealth/frontera-ui-components";

export const EditedLabel: React.FC<{ editedAt: string }> = ({ editedAt }) => {
  const date = new Date(editedAt);
  if (!isValid(date)) return null;

  return (
    <Small className="text-text-tertiary">
      <time dateTime={date.toISOString()} title={format(date, "MMM d, yyyy 'at' h:mm a")}>
        Edited {formatRelativeTime(date)}
      </time>
    </Small>
  );
};
